<script>
export default {
  props: {
    value: { type: Array, required: true },
    cart: { type: Object, default: () => {} },
    ratePlan: { type: Object, required: true },
  },
  data() {
    return {
      showPicker: false,
    }
  },
  computed: {
    showExtraBed() {
      return !!this.ratePlan.occupancy.extraBeds && this.cart
    },
    extraBedsArray() {
      return [...Array(this.ratePlan.occupancy.extraBeds + 1).keys()]
    },
    extraBedModel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    cart(val) {
      if (!val) {
        this.showPicker = false
      }
    },
  },
  methods: {
    removeExtraBed() {
      this.showPicker = false
      this.$emit('input', Array(this.value.length).fill(0))
    },
    doUpdate(e, index) {
      const item = this.value.slice()
      item.splice(index, 1, Number(e.target.value))
      this.$emit('input', item)
    },
  },
}
</script>

<template>
  <div v-if="showExtraBed" class="mt-3">
    <template v-if="showPicker">
      <div v-for="(qty, index) in cart.extrabed" :key="index">
        <div class="text-sm font-medium">Extra bed room {{ index + 1 }}</div>
        <div class="relative mb-3">
          <select
            :value="value[index]"
            class="input"
            @change="(e) => doUpdate(e, index)"
          >
            <option
              v-for="(bedQty, bedIndex) in extraBedsArray"
              :key="bedIndex"
              :value="bedQty"
            >
              <template v-if="bedQty < 1">
                0
              </template>
              <template v-else>
                {{ `${bedQty}x ${ratePlan.rate.extraBed.currency}` }}
                {{ (bedQty * ratePlan.rate.extraBed.display) | currency }}
              </template>
            </option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
          >
            <BaseIcon name="chevron-down" />
          </div>
        </div>
      </div>
      <a
        class="text-sm font-medium text-red-600 cursor-pointer hover:underline"
        @click="removeExtraBed"
      >
        Remove extra bed
      </a>
    </template>
    <a
      v-else
      class="text-sm font-medium text-blue-600 cursor-pointer hover:underline"
      @click="showPicker = true"
    >
      Need extra bed?
    </a>
  </div>
</template>
